import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

export const getCierreClientes = async(dates, IdCalendario) =>{
    const result = await PrivateInterceptor(`Clientes/CierreClientes/Fechas`, 'POST', {FechaInicio :dates[0], FechaFinal: dates[1], IdCalendario: IdCalendario} );
    return result;
}
